import { Link } from "react-router-dom";

function Header() {
  return (
    <header style={styles.header}>
      <h1 style={styles.logo}>Little Lemon 🍋</h1>

      <nav>
        <Link style={styles.link} to="/">Home</Link>
        <Link style={styles.link} to="/menu">Menu</Link>
        <Link style={styles.link} to="/booking">Book Table</Link>
      </nav>
    </header>
  );
}

const styles = {
  header: {
    background: "rgba(0,0,0,0.85)",
    padding: "20px",
    textAlign: "center",
    position: "sticky",
    top: "0",
    zIndex: "1000"
  },

  logo: {
    margin: "0",
    color: "#f4ce14"
  },

  link: {
    color: "#f4ce14",
    margin: "0 15px",
    textDecoration: "none",
    fontWeight: "bold"
  }
};

export default Header;